import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared";

@Injectable()
export class PrintService {
	constructor(private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueCheckLockoutBySchool
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueCheckLockoutBySchool(schoolID) {
		var postResult$ = new Subject();
		var url = "ExpressIDCardPrinting/IDPrintQueueCheckLockoutBySchool?SchoolID=" + schoolID;
		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	StudentInQueueList
	//
	//-----------------------------------------------------------------------------------------------------
	StudentInQueueList(schoolID, IsSubmmited) {
		var postResult$ = new Subject();
		var url = "ExpressIDCardPrinting/StudentInQueueList?SchoolID=" + schoolID + "&IsSubmitted=" + IsSubmmited;
		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ActionOnStudentInQueueList
	//
	//-----------------------------------------------------------------------------------------------------
	ActionOnStudentInQueueList(newArray) {
		var postResult$ = new Subject();
		var url = "ExpressIDCardPrinting/ActionOnStudentInQueueList";
		var promise$ = this.httpclientService.post(url, newArray);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	printTempID
	//
	//-----------------------------------------------------------------------------------------------------
	printTempID(personID, schoolID) {
		var strParam = personID + "|PersonID";
		var reportFileName = "RPTTemporaryCardMain.rpx";
		var postResult$ = new Subject();
		var url = "Report/PrintByReportFileName?ReportFileName=" + reportFileName + "&strParam=" + strParam + "&schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	printerTempID
	//
	//-----------------------------------------------------------------------------------------------------
	printerTempID(personID, schoolID) {
		var strParam = personID + "|PersonID";
		var reportFileName = "RPTTemporaryCard.rpx";
		var postResult$ = new Subject();
		var url = "Report/PrintByReportFileName?ReportFileName=" + reportFileName + "&strParam=" + strParam + "&schoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
